const encoder = new TextEncoder();
const decoder = new TextDecoder();
export class XRPCResponse {
  constructor(data, headers) {
    this.data = data;
    this.headers = headers;
  }
  success = true;
}
export class XRPCError extends Error {
  constructor(status, error, message) {
    super(message || error);
    this.status = status;
    this.error = error;
    this.name = "XRPCError";
  }
  success = false;
}
export var ResponseType = /* @__PURE__ */ ((ResponseType2) => {
  ResponseType2[ResponseType2["Unknown"] = 1] = "Unknown";
  ResponseType2[ResponseType2["InvalidResponse"] = 2] = "InvalidResponse";
  ResponseType2[ResponseType2["Success"] = 200] = "Success";
  ResponseType2[ResponseType2["InvalidRequest"] = 400] = "InvalidRequest";
  ResponseType2[ResponseType2["AuthRequired"] = 401] = "AuthRequired";
  ResponseType2[ResponseType2["Forbidden"] = 403] = "Forbidden";
  ResponseType2[ResponseType2["XRPCNotSupported"] = 404] = "XRPCNotSupported";
  ResponseType2[ResponseType2["PayloadTooLarge"] = 413] = "PayloadTooLarge";
  ResponseType2[ResponseType2["RateLimitExceeded"] = 429] = "RateLimitExceeded";
  ResponseType2[ResponseType2["InternalServerError"] = 500] = "InternalServerError";
  ResponseType2[ResponseType2["MethodNotImplemented"] = 501] = "MethodNotImplemented";
  ResponseType2[ResponseType2["UpstreamFailure"] = 502] = "UpstreamFailure";
  ResponseType2[ResponseType2["NotEnoughResouces"] = 503] = "NotEnoughResouces";
  ResponseType2[ResponseType2["UpstreamTimeout"] = 504] = "UpstreamTimeout";
  return ResponseType2;
})(ResponseType || {});
export const httpResponseCodeToEnum = (status) => {
  if (status in ResponseType) {
    return status;
  } else if (status >= 100 && status < 200) {
    return 404 /* XRPCNotSupported */;
  } else if (status >= 200 && status < 300) {
    return 200 /* Success */;
  } else if (status >= 300 && status < 400) {
    return 404 /* XRPCNotSupported */;
  } else if (status >= 400 && status < 500) {
    return 400 /* InvalidRequest */;
  } else {
    return 500 /* InternalServerError */;
  }
};
export const constructMethodCallUri = (nsid, serviceUri, params) => {
  const uri = new URL(`/xrpc/${nsid}`, serviceUri);
  if (params) {
    for (const key in params) {
      const value = params[key];
      if (value !== void 0) {
        if (Array.isArray(value)) {
          for (let idx = 0, len = value.length; idx < len; idx++) {
            const val = value[idx];
            uri.searchParams.append(key, val);
          }
        } else {
          uri.searchParams.set(key, value);
        }
      }
    }
  }
  return uri.toString();
};
export const constructMethodCallHeaders = (headers, method, data, encoding) => {
  if (method === "post") {
    if (data && typeof data === "object") {
      if (!headers["Content-Type"]) {
        headers["Content-Type"] = "application/json";
      }
    }
    if (encoding) {
      headers["Content-Type"] = encoding;
    }
  }
  return headers;
};
export const encodeMethodCallBody = (headers, data) => {
  if (!headers["Content-Type"] || typeof data === "undefined") {
    return void 0;
  }
  if (data instanceof ArrayBuffer || data instanceof Blob) {
    return data;
  }
  if (headers["Content-Type"].startsWith("text/")) {
    return encoder.encode(data.toString());
  }
  if (headers["Content-Type"].startsWith("application/json")) {
    return encoder.encode(JSON.stringify(data));
  }
  return data;
};
export const httpResponseBodyParse = (mimeType, data) => {
  if (mimeType) {
    if (mimeType.includes("application/json") && data?.byteLength) {
      try {
        const str = decoder.decode(data);
        return JSON.parse(str);
      } catch (e) {
        throw new XRPCError(2 /* InvalidResponse */, `Failed to parse response body: ${String(e)}`);
      }
    }
    if (mimeType.startsWith("text/") && data?.byteLength) {
      try {
        return decoder.decode(data);
      } catch (e) {
        throw new XRPCError(2 /* InvalidResponse */, `Failed to parse response body: ${String(e)}`);
      }
    }
  }
  if (data instanceof ArrayBuffer) {
    return new Uint8Array(data);
  }
  return data;
};
